import formatTimestampAsParameter from './formatTimestampAsParameter';
import getCategoryParameters from './getCategoryParameters';

export default function getArticlesParameters(article) {
  const categoryParameters = getCategoryParameters(article.category);

  return {
    ...categoryParameters,
    slug: article.slug || null,
    insertedAt: formatTimestampAsParameter(article.insertedAt),
    id: article.id,
  };
}
